/* Kervo cart helpers — slim. Announcement rotation + cart add-ons only.
   (Reservation-countdown timer removed with the cart header extras: it ran a
   1s setInterval and wrote sessionStorage on every cart:update, which janked the
   mobile cart. Cuprex-era cart syncs were removed earlier for the same reason.) */
(function(){
  function initAnno(){
    var wrap=document.querySelector('.announcement-bar__slides'); if(!wrap||wrap.dataset.cxA) return;
    var slides=[].slice.call(wrap.children).filter(function(n){return n.nodeType===1;});
    if(slides.length===0) return;
    wrap.dataset.cxA='1';
    try{ var comp=document.querySelector('announcement-bar-component'); if(comp&&comp.pause) comp.pause(); }catch(e){}
    slides.forEach(function(s,idx){ s.classList.toggle('cx-anno-active', idx===0); });
    if(slides.length<2) return;
    var i=0;
    setInterval(function(){ slides[i].classList.remove('cx-anno-active'); i=(i+1)%slides.length; slides[i].classList.add('cx-anno-active'); }, 4000);
  }
  if(document.readyState!=='loading') initAnno(); else document.addEventListener('DOMContentLoaded', initAnno);
  window.addEventListener('load', initAnno);
})();

/* Kervo cart add-ons — "Upgrade your order" upsell (+) and shipping-protection toggle.
   Uses document-level delegation so it survives cart-drawer re-renders, and refreshes
   the cart natively by dispatching the theme's 'cart:update' event with rendered sections. */
(function(){
  function sectionIds(){
    var seen={}, out=[];
    document.querySelectorAll('[data-section-id]').forEach(function(el){
      var id=el.getAttribute('data-section-id');
      if(id && !seen[id]){ seen[id]=1; out.push(id); }
    });
    return out;
  }
  function mutate(url, body){
    body.sections = sectionIds().join(',');
    body.sections_url = location.pathname;
    return fetch(url, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify(body)})
      .then(function(r){ return r.json(); })
      .then(function(data){
        return fetch('/cart.js', {headers:{'Accept':'application/json'}})
          .then(function(r){ return r.json(); })
          .then(function(cart){
            document.dispatchEvent(new CustomEvent('cart:update', {bubbles:true, detail:{
              resource:cart, sourceId:'kervo-addons',
              data:{ source:'kervo-addons', itemCount:cart.item_count, sections:(data && data.sections) || {} }
            }}));
            return cart;
          });
      });
  }
  document.addEventListener('click', function(e){
    var add = e.target.closest('[data-kv-upsell-add]');
    if(add){
      e.preventDefault();
      var card = add.closest('.kv-upsell__card');
      var sizeEl = card && card.querySelector('[data-kv-upsell-size]');
      var vid = sizeEl ? parseInt(sizeEl.value,10) : 0;
      if(!vid) return;
      add.setAttribute('disabled','');
      mutate('/cart/add.js', {items:[{id:vid, quantity:1}]}).catch(function(){}).then(function(){ add.removeAttribute('disabled'); });
      return;
    }
    var sw = e.target.closest('[data-cx-prot]');
    if(sw){
      e.preventDefault();
      if(sw.hasAttribute('disabled')) return;
      var isOn = sw.classList.contains('is-on');
      sw.setAttribute('disabled','');
      sw.classList.toggle('is-on');            // optimistic
      sw.setAttribute('aria-checked', String(!isOn));
      var p;
      if(isOn){
        var key = sw.getAttribute('data-key');
        p = mutate('/cart/change.js', {id:key, quantity:0});
      } else {
        var variant = parseInt(sw.getAttribute('data-variant'),10);
        p = mutate('/cart/add.js', {items:[{id:variant, quantity:1, properties:{_protection:'true'}}]});
      }
      p.catch(function(){ sw.classList.toggle('is-on'); sw.setAttribute('aria-checked', String(isOn)); })
       .then(function(){ sw.removeAttribute('disabled'); });
      return;
    }
  });
})();

/* Kervo — free gifts are BUNDLED into the pad line (one "Free Gifts" line-item property,
   shown in checkout + on the order). They are no longer separate $0 cart lines, because
   auto-adding/removing them fought with customers removing items and glitched the cart.
   One-time cleanup: drop any leftover $0 gift lines from older carts (runs once per session,
   never re-adds anything). */
(function(){
  var OLD=[44916841316403,44927615139891];
  try{ if(sessionStorage.getItem('kv_gift_clean')) return; sessionStorage.setItem('kv_gift_clean','1'); }catch(e){}
  fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){
    var upd={}, n=0;
    cart.items.forEach(function(i){ if(OLD.indexOf(i.variant_id)>-1){ upd[i.key]=0; n++; } });
    if(!n) return;
    return fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:upd})})
      .then(function(){ document.dispatchEvent(new CustomEvent('cart:update',{bubbles:true,detail:{source:'kervo-gift-cleanup'}})); });
  }).catch(function(){});
})();
